/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly creatorDesignTiles: ReadonlyArray<{
        readonly displayName: string | null;
        readonly imageUrl: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespDesignsDescriptionTile_itemSearch">;
    readonly " $refType": "SbRespDesignTiles_itemSearch";
};
export type SbRespDesignTiles_itemSearch$data = SbRespDesignTiles_itemSearch;
export type SbRespDesignTiles_itemSearch$key = {
    readonly " $data"?: SbRespDesignTiles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespDesignTiles_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespDesignTiles_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creatorDesignTiles",
      "storageKey": null,
      "args": null,
      "concreteType": "CreatorDesignTiles",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespDesignsDescriptionTile_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'c735b8935d8e17bfd8540f0c10b8f845';
export default node;
